import "../kendo.core.js";
import "../kendo.data.js";

(function($, kendo) {

    const extend = $.extend;

    const CSVDataProvider = kendo.Class.extend({
        init: function(options) {
            this.options = options;
            const dataSource = options.dataSource;

            if (dataSource instanceof kendo.data.DataSource) {

                if (!dataSource.filter()) {
                    dataSource.options.filter = undefined;
                }

                this.dataSource = new dataSource.constructor(extend(
                    {},
                    dataSource.options,
                    {
                        page: options.allPages ? 0 : dataSource.page(),
                        filter: dataSource.filter(),
                        pageSize: options.allPages ? dataSource.total() : dataSource.pageSize() || dataSource.total(),
                        sort: dataSource.sort(),
                        group: dataSource.group(),
                        aggregate: dataSource.aggregate()
                    }));

                const data = dataSource.data();

                if (data.length > 0) {
                    this.dataSource._data = data;

                    const transport = this.dataSource.transport;
                    if (dataSource._isServerGrouped && dataSource._isServerGrouped() && transport.options && transport.options.data) {
                        transport.options.data = null;
                    }
                }

            } else {
                this.dataSource = kendo.data.DataSource.create(dataSource);
            }
        },

        export: function() {
            return $.Deferred((function(d) {
                this.dataSource.fetch()
                    .then((function() {
                        const data = this.dataSource.view();
                        let csvData = data;

                        if (csvData.length && csvData[0] && csvData[0].field !== undefined && csvData[0].items !== undefined) {
                            csvData = {
                                data: csvData,
                                total: csvData.length
                            };
                        }

                        d.resolve(csvData);
                    }).bind(this));
            }).bind(this)).promise();
        }
    });

    kendo.CSVDataProvider = CSVDataProvider;

})(kendo.jQuery, kendo);